import SaveQuotationMapper from '@/modules/common/common/mappers/MID/SaveQuotationMapper'
import GetCoveragesBasicMapper from '@/modules/common/common/mappers/DXP/GetCoveragesBasicMapper'
import GetPaymentURLMapper from '@/modules/common/common/mappers/MID/GetPaymentURLMapper'

export default {
  SaveQuotationMapper,
  GetCoveragesBasicMapper,
  GetPaymentURLMapper
}
